import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

function NotFoundRedirect() {
  const location = useLocation();
  const from = `${location.pathname}${location.search}${location.hash}`;

  return <Navigate to="/404" replace state={{ from }} />;
}

export default NotFoundRedirect;
